import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Stack } from '@bingads-webui-react/fabric-control';
import { ScopeLevel } from '@bingads-webui-campaign-react/constants';
import {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionPanel,
} from '@fluentui/react-components';
import { IpExclusions } from './ip-exclusions';
import { SiteExclusions } from './site-exclusions';

export const WebExclusions = ({
  showSiteExclusion,
  showIPExclusion,
  showAccordion,
  siteInputProps,
  ipInputProps,
  level,
  exclusionData,
  setExclusionsCallback,
  errors,
}) => {
  const i18n = useContext(I18nContext);
  const siteExclusions =
    level === ScopeLevel.Campaign
      ? _.result(
        exclusionData && exclusionData.campaignExclusions,
        'ExcludedSites'
      )
      : _.result(
        exclusionData && exclusionData.adgroupExclusions,
        'ExcludedSites'
      ) || '';
  const campaignReadOnlySiteExclusions =
    level === ScopeLevel.AdGroup
      ? _.result(
        exclusionData && exclusionData.campaignExclusions,
        'ExcludedSites'
      )
      : '';
  const ipExclusions =
    _.result(
      exclusionData && exclusionData.campaignExclusions,
      'ExcludedIPs'
    ) || '';

  const hasSiteExclusionsErrors = errors.find(error => 'NegativeSitesResult' in error);
  const hasIpExclusionsErrors = errors.find(error => 'NegativeIPsResult' in error);

  const siteExclusionsError = hasSiteExclusionsErrors
    ? hasSiteExclusionsErrors.NegativeSitesResult
    : [];
  const ipExclusionsError = hasIpExclusionsErrors
    ? hasIpExclusionsErrors.NegativeIPsResult
    : [];

  const handleExclusionInputChange = ({ value, type }) => {
    setExclusionsCallback(value, type);
  };

  const siteExclusionsInput = (
    <SiteExclusions
      {...siteInputProps}
      level={level}
      exclusions={siteExclusions}
      readOnlyExclusions={campaignReadOnlySiteExclusions}
      handleExclusionInputChange={handleExclusionInputChange}
      errors={siteExclusionsError}
    />
  );

  const ipExclusionsInput = (
    <IpExclusions
      {...ipInputProps}
      exclusions={ipExclusions}
      handleExclusionInputChange={handleExclusionInputChange}
      errors={ipExclusionsError}
    />
  );

  return (
    <div className="web-exclusions-container">
      {showAccordion ? (
        <Accordion multiple collapsible>
          {showSiteExclusion && (
            <AccordionItem value="1">
              <AccordionHeader>{i18n.getString(_TL_('Add websites'))}</AccordionHeader>
              <AccordionPanel>
                {siteExclusionsInput}
              </AccordionPanel>
            </AccordionItem>
          )}
          {showIPExclusion && (
            <AccordionItem value="2">
              <AccordionHeader>{i18n.getString(_TL_('Manually add IP addresses'))}</AccordionHeader>
              <AccordionPanel>
                {ipExclusionsInput}
              </AccordionPanel>
            </AccordionItem>
          )}
        </Accordion>
      ) : (
        <Stack tokens={{ childrenGap: 16 }}>
          {showSiteExclusion && siteExclusionsInput}
          {showIPExclusion && ipExclusionsInput}
        </Stack>
      )}
    </div>
  );
};

WebExclusions.propTypes = {
  showSiteExclusion: PropTypes.bool,
  showIPExclusion: PropTypes.bool,
  showAccordion: PropTypes.bool,
  siteInputProps: PropTypes.shape({}),
  ipInputProps: PropTypes.shape({}),
  level: PropTypes.string.isRequired,
  exclusionData: PropTypes.shape({}).isRequired,
  setExclusionsCallback: PropTypes.func.isRequired,
  errors: PropTypes.shape([]),
};

WebExclusions.defaultProps = {
  showSiteExclusion: false,
  showIPExclusion: false,
  showAccordion: false,
  siteInputProps: {},
  ipInputProps: {},
  errors: [],
};
